export const setUserShadowBanById = (array, userId, payload) => {
    return array?.map((item) => {
        if (item.user.id === userId) {
            item.user.isShadowBanned = payload
        }
        return item
    })
}